/* eslint-disable max-len */
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';
import { PRODUCT_TYPES } from '../../../utils/catalog';
import { stepIds } from '../../../flowDefinition/stepIds';


export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.legalNSubmit.buttonText]: 'Confirmar pedido',
      [STRING_KEYS.provisionalAgreement.title]: 'Puedes ',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'descargar el resumen del contrato',
      [STRING_KEYS.provisionalAgreement.postTitle]: ' de los nuevos servicios que vas a contratar',
      [STRING_KEYS.process.title]: '',
      [STRING_KEYS.mobileSecondaryAction.lmaStepAvice.title]: 'Las líneas móviles extra podrás configurarlas más adelante en el proceso',
      [STRING_KEYS.mobileSecondaryAction.lmaStepAvice.steps]: [ stepIds.mobileSecondaryAction ],
      [STRING_KEYS.stepTitles.mobileSecondaryAction]: 'Configuración líneas móviles incluidas en miMovistar',
      [STRING_KEYS.stepTitles.alreadyOwnedProductsChoices]: 'Configuración líneas móviles incluidas en miMovistar',
      [STRING_KEYS.shipment.text]: 'Recibirás La tarjeta SIM en la dirección que nos indiques. Entrega en Madrid y Barcelona: 48h. Resto de península, Baleares y Canarias: 72h. Excepto festivos.',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI - ERROR TELCO RIESGO MIMOVISTAR NO AT',
      [STRING_KEYS.se.order.subject]: 'TELCOBI - COMPRA BUNDLE-REPO-AUTO',
      [STRING_KEYS.se.shippingMobileInsurance.subject]: 'TELCOBI - COMPRA SEGURO TERMINAL R2R miMovistar Auto',
      [STRING_KEYS.se.message.error.title]: 'Tipo Error',
      [STRING_KEYS.se.message.error.description]: 'Descripción del error',
      [STRING_KEYS.se.message.shipping.type]: 'TIPO ENVÍO',
      [STRING_KEYS.se.message.shipping.address]: 'DIRECCION ENVÍO',
      [STRING_KEYS.se.message.payment.account]: 'CUENTA BANCARIA',
      [STRING_KEYS.se.message.shoppingCart.title]: 'INFORMACION VENTA DE PRODUCTOS',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.INCLUDED_R2R]]: 'R2R',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.ADDITIONAL_R2R]]: 'R2R',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.ADDITIONAL_MOBILE]]: 'LMA',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.TV]]: 'TV',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.NETFLIX]]: 'NETFLIX',
      [STRING_KEYS.alreadyOwnedProductsChoices.obligateChoicesTitle]: '¿Qué vas a hacer con el resto tus líneas móviles?',
      [STRING_KEYS.alreadyOwnedProductsChoices.obligateChoicesLine]: 'Línea: ',
      [STRING_KEYS.alreadyOwnedProductsChoices.selectTitle]: 'Número móvil​',
      [STRING_KEYS.alreadyOwnedProductsChoices[CQ_ACTION_CODES.UNSUBSCRIBE]]: 'Dar de baja',
      [STRING_KEYS.alreadyOwnedProductsChoices[CQ_ACTION_CODES.MIGRATION]]: 'Pasarla a contrato Movistar',
      [STRING_KEYS.alreadyOwnedProductsChoices.migrationLonely]: 'Pasarla a contrato ',
      [STRING_KEYS.legalNSubmit.legalCheckout.linkableText]: 'condiciones particulares, generales, de desistimiento y cesión de datos.',
      [STRING_KEYS.legalNSubmit.dataTransferTitle]: 'Cesión de datos',
      [STRING_KEYS.legalNSubmit.dataTransferText]: 'Si contratas Dazn, para poder ver su contenido es necesario que Telefónica comunique tu email de cliente Movistar y un ID de identificación con Dazn, para ejecutar el contrato del que eres parte. Además, aceptas las Condiciones de uso de Dazn y su Política de Privacidad, disponibles en dazn.com, pudiendo ejercer tus derechos conforme a lo indicado en su política de privacidad',
      [STRING_KEYS.summary.mainActionSelected.title]: 'Dirección de instalación',
      [STRING_KEYS.summary.mobileLineAction.title]: 'Línea móvil incluida',
      [STRING_KEYS.summary.mobileLineAction.multipleActionsTitle]: 'Líneas móviles incluidas',
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.REGISTER]]: 'Línea nueva',
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.PORTABILITY]]: 'Traigo un nº de otro operador (portabilidad)',
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.MIGRATION]]: 'Línea fija Movistar',
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.KEEP]]: 'Quiero mantener mi número',
      [STRING_KEYS.summary.productBarInfo.additionalInfoText]: 'Dirección',
      [STRING_KEYS.summary.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Resto de península, Baleares y Canarias: 72h. Excepto festivos.',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.summary.staticDirectDebit]: 'En tu factura Movistar.',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID].cartText]: 'Con instalación de un técnico',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID].cartText]: 'Autoinstalación: entrega en 48/72h',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT].cartText]: 'Autoinstalación: entrega en 48/72h',
      [STRING_KEYS.deviceSummaryCart.hguWithoutCost]: 'Router Smart WiFi 6',
      [STRING_KEYS.deviceSummaryCart.uhdDecoderWithoutCost]: 'Descodificador UHD',
      [STRING_KEYS.deviceSummaryCart.uhdWifiDecoder]: 'Descodificador UHD Smart WiFi',
      [STRING_KEYS.summary.installation.advice.title]: 'Información adicional:',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: 'Te llamaremos para que un técnico vaya a tu domicilio. Si has solicitado Fibra 10 Gb la nueva velocidad no será efectiva hasta que se realice la instalación.',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]]: 'Te enviaremos un nuevo equipo en 48/72 h. Si has solicitado Fibra 10 Gb la nueva velocidad no séra efectiva hasta que no conectes el nuevo equipo.',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]]: 'Te enviaremos un nuevo equipo en 48/72 h. Si has solicitado Fibra 10 Gb la nueva velocidad no séra efectiva hasta que no conectes el nuevo equipo.',
      [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
        [STRING_KEYS.summary.mainActionSelected.value]: 'Número nuevo',
        [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: 'Te llamaremos para que un técnico vaya a tu domicilio.',
      },
      [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
        [STRING_KEYS.summary.mainActionSelected.value]: '{phoneNumber}',
      },
      [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
        [STRING_KEYS.summary.mainActionSelected.value]: '{phoneNumber}',
      },
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
      [STRING_KEYS.process.title]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
